import {
    ref,
    reactive,
    watch,
    watchEffect,
    computed
} from 'vue'
import {
    fetchArticleList,
    fetchCategory,
    fetchDetail,
} from '../apis/type'
import {
    lastValueFrom
} from 'rxjs'
import {
    useRoute,
    useRouter
} from 'vue-router'

import {
    forkJoin,
    from
} from "rxjs";
import {
    mergeMap,
    map,
    takeUntil
} from "rxjs/operators";
import wxshare from "../utils/wxshare";



export default function useData() {

    const $route = useRoute();
    const $router = useRouter();

    let categoryList = reactive([

        {
            id: '237446',
            name: '头条',
            page: 1,
            list: [],
            cursor: 0,
        },
        {
            id: '311502',
            name: '热点',
            page: 1,
            list: [],
            cursor: 0,
        },
        {
            id: '311503',
            name: '视频',
            page: 1,
            list: [],
            cursor: 0,
        },
        {
            id: '311504',
            name: '图片',
            page: 1,
            list: [],
            cursor: 0,
        },


    ])
    const PageSize = ref(10)


    const curCategoryIndex = ref(0)
    const curCategory = computed(() => {
        return categoryList[curCategoryIndex.value]
    })

    const curFlycardList = computed(() => {
        return categoryList[curCategoryIndex.value] ? categoryList[curCategoryIndex.value].list : []
    })
    const curFlycardIndex = computed(() => {
        return categoryList[curCategoryIndex.value] ? categoryList[curCategoryIndex.value].cursor : 0
    })
    const curFlycard = computed(() => {
        let index = curFlycardIndex.value
        let list = curFlycardList.value
        return list[index]
    })


    const changeCurCategory = (direction) => {
        let len = categoryList.length
        if (direction) {
            curCategoryIndex.value++
            if (curCategoryIndex.value == len) curCategoryIndex.value = 0
        } else {
            curCategoryIndex.value--
            if (curCategoryIndex.value == -1) curCategoryIndex.value = len - 1
        }
    }


    const categoryHandler = (data) => {

        return data = data.map((category, index) => {
            return {
                name: category.cnname,
                logo: logoList.value[index],
                id: category.tid,
                page: 1,
                list: [],
                initialize: false, // 是否初始化完成
                cursor: 0,
            }
        })
    }


    const initCategoryList = async () => {
        let {
            categoryId
        } = $route.query
        console.log('here');
        let res = await lastValueFrom(fetchCategory(categoryId))
        console.log(res);



        let index = res.findIndex(item => item.id == categoryId)
        res = [...res.slice(index), ...res.slice(0, index)]
        console.log('res === ', res);

        // categoryList.push(...categoryHandler(res))
    }


    const initFlycardList = async (index, categoryId, page) => {

        let res = await lastValueFrom(fetchArticleList(categoryId, page))


        categoryList[index].list = [...categoryList[index].list, ...res]
    }

    const initFlycardContent = async (categoryId, articleId) => {


        return await lastValueFrom(fetchDetail(articleId, categoryId))

    }





    const setShare = () => {
        setTimeout(() => {
            let cur = curFlycard.value
            let url = window.location.href
            if (!!cur) {
                if (!window.wx) {

                    wxshare.setWxShareMsg(
                        cur["title"],
                        cur["outline"] || cur["title"],
                        'https://appatt.sznews.com/jzApp/files/flycard/wxshare.jpg',
                        url,
                        ""
                    );

                } else {

                    wxshare.ShareLocal(
                        cur["title"],
                        cur["outline"] || cur["title"],
                        'https://appatt.sznews.com/jzApp/files/flycard/wxshare.jpg',
                        url,
                        ""
                    );

                }

            }

        }, 30);


    }

    watch($route, (to, from) => {

        if (!categoryList[0]['list'].length) {

            initCategoryList()


            let init$ = fetchArticleList($route.query.categoryId || categoryList[0]['id'], $route.query.page).pipe(

                mergeMap((l) => {
                    let {
                        categoryId,
                        articleId
                    } = $route.query;
                    articleId = $route.query.articleId ? $route.query.articleId : l[0]["articleId"];

                    categoryId = $route.query.categoryId ? $route.query.categoryId : categoryList[0]["id"];

                    let cindex = categoryList.findIndex(e => e['id'] === categoryId)
                    // categoryList

                    let tmp = categoryList
                    tmp = [...tmp.slice(cindex), ...tmp.slice(0, cindex)]

                    return fetchDetail(articleId).pipe(
                        map(d => {
                            let index = l.findIndex((e) => e['articleId'] === d['articleId']);
                            if (index < 0) {
                                l.unshift(d)
                            } else {
                                l = [l[index], ...l.slice(0, index), ...l.slice(index + 1)];
                            }


                            tmp[0]['list'].push(...l)
                            return tmp
                        })
                    )
                })
            )



            // app初始化
            init$.subscribe({
                next: (e) => {

                    categoryList.length = 0
                    categoryList.push(...e)
                    console.log('categoryList ', categoryList);

                    setShare()

                },
            });

        }
        setShare()

    })




    watchEffect(async () => {
        if (categoryList[0]['list'].length) {

            // console.log(curCategory.value);
            if (!curCategory.value.list.length && !curCategory.value.initialize) {
                // 栏目初始化
                curCategory.value.initialize = true
                await initFlycardList(curCategoryIndex.value, curCategory.value.id, curCategory.value.page)

            }


            if (curCategory.value.cursor === curCategory.value.list.length - 3 && curCategory.value.list[0].hasNextPage) {
                // 快到底
                await initFlycardList(curCategoryIndex.value, curCategory.value.id, curCategory.value.page + 1)
            }

            if (curCategory.value.cursor && curCategory.value.cursor / PageSize.value === curCategory.value.page) {
                // 翻页
                categoryList[curCategoryIndex.value].page++
            }




            let curArticle = curCategory.value.list[curCategory.value.cursor]
            document.title = curArticle.title


            if (!curArticle.content) {
                let res = await initFlycardContent(curCategory.value.id, curArticle.articleId)
                curArticle['content'] = res.content
                if (curArticle.type === '1') curArticle['videourl'] = res.videourl
            }

            $router.replace({
                path: '/',
                query: {
                    categoryId: curCategory.value.id,
                    page: curCategory.value.page,
                    articleId: curArticle['articleId'],
                }
            })




        }




    })







    return {
        categoryList,
        curCategory,
        curCategoryIndex,
        curFlycardList,
        curFlycardIndex,
        curFlycard,
        changeCurCategory,
    }
}